export default __webpack_public_path__ + "static/banner1-d780cab3e2b48a9a10ca1e1edf953047.png";